import { React, useState, useEffect } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { useDrag } from 'react-dnd';


export default function TagItem(props) {

    const [ { isDragging }, drag] = useDrag(() => ({
        type: 'TAG',
        item: {tagId: props.tagId, tagType: props.tagType},
        collect: (monitor) => (
        {
            isDragging: !!monitor.isDragging()
        })
    }),
    [props.itemCount])

return(
<ListGroup.Item ref={drag} key={props.tagId} action active={isDragging} >{props.tagId}</ListGroup.Item>
)
}